import { Card as FlowbiteCard } from 'flowbite-react';
import type { FunctionComponent } from 'react';

import { Flexbox } from '../flexbox/flexbox';
import { Paragraph } from '../paragraph/paragraph';
import type { CardProps } from './types';

const customTheme = {
  root: {
    base: 'flex w-auto rounded-card bg-white',
    children: 'flex h-full flex-col justify-start',
    horizontal: {
      off: 'flex-col',
      on: 'flex-col md:max-w-xl md:flex-row'
    }
  }
};

export const Card: FunctionComponent<CardProps> = ({
  title,
  subtitle,
  titleVariant = 'h4',
  subtitleVariant = 'text-base',
  fullWidth = false,
  fullHeight = false,
  icons = null,
  children,
  className,
  ...props
}) => {
  const renderHeader = () => {
    return (
      <>
        {title && (
          <Flexbox justify='between'>
            <Paragraph variant={titleVariant}>{title}</Paragraph>
            {icons}
          </Flexbox>
        )}
        {subtitle && (
          <Paragraph variant={subtitleVariant} className='grow py-1 small:py-0'>
            {subtitle}
          </Paragraph>
        )}
      </>
    );
  };

  const cardClasses = `p-4 ${fullWidth ? 'w-full' : ''} ${fullHeight ? 'h-full' : ''} ${className ?? ''}`;

  return (
    <FlowbiteCard {...props} theme={customTheme} className={cardClasses}>
      {renderHeader()}
      {children}
    </FlowbiteCard>
  );
};
